// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../../css-loader/dist/cjs.js??ref--6-1!../../../../postcss-loader/src/index.js!../global/global.css");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../css-loader/dist/cjs.js??ref--6-1!../../../../postcss-loader/src/index.js!../global/variables.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
exports.push([module.id, ".pager_343 {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n\n.links_60b {\n  margin-bottom: 16px;\n}\n\n.link_421 {\n  display: inline-block;\n\n  margin-right: 16px;\n}\n\n.linkDisabled_a16 {\n  color: #737577;\n  color: var(--ring-secondary-color);\n}\n", ""]);
// Exports
exports.locals = {
	"unit": "" + ___CSS_LOADER_ICSS_IMPORT_0___.locals["unit"] + "",
	"pager": "pager_343",
	"links": "links_60b",
	"link": "link_421",
	"linkDisabled": "linkDisabled_a16"
};
module.exports = exports;
